module.exports = __webpack_public_path__ + "assets/4461c27fb9544b8825038fa9e6c534eb.png";